var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-lang-select", {
                    model: {
                      value: _vm.lang,
                      callback: function ($$v) {
                        _vm.lang = $$v
                      },
                      expression: "lang",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("top"),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "4" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("text") },
                    model: {
                      value: _vm.value.Text.Translations[_vm.lang],
                      callback: function ($$v) {
                        _vm.$set(_vm.value.Text.Translations, _vm.lang, $$v)
                      },
                      expression: "value.Text.Translations[lang]",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "4" } },
                [
                  _c("app-prop-select-autocomplete", {
                    attrs: {
                      label: _vm.$ct("prop"),
                      fancy: "",
                      items: _vm.props,
                      "allow-empty": "",
                    },
                    model: {
                      value: _vm.value.Prop,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Prop", $$v)
                      },
                      expression: "value.Prop",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "4" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("text-after") },
                    model: {
                      value: _vm.value.TextAfter.Translations[_vm.lang],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value.TextAfter.Translations,
                          _vm.lang,
                          $$v
                        )
                      },
                      expression: "value.TextAfter.Translations[lang]",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("default"),
          _vm._l(_vm.value.Conditions, function (condition, i) {
            return _c(
              "w-transition-slide-height",
              { key: condition.key },
              [
                _vm.shouldShowKey(condition.key)
                  ? _c("app-field-condition-edit", {
                      attrs: {
                        value: condition,
                        "is-first": i == 0,
                        fields: _vm.conditionProps,
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.removeCondition(i)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _c(
            "w-row",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "plus" },
                  on: {
                    click: function ($event) {
                      return _vm.addCondition()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("add-filter")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }